// extracted by mini-css-extract-plugin
export default {"drawer":"fW","drawerheader":"gW","retake_quiz_bottom_bar":"hW","extra_drawer":"iW","not_answered_questions":"jW","question_ui":"kW","accordion_details":"lW","retake_quiz":"mW","accordions":"nW","accordion_root":"oW","accordion_summary_text":"pW","animation":"qW","show_animation":"rW","overflow_hidden":"sW"};
    if(module.hot) {
      // 1721922366357
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  